import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from './FaveNotification';
import { collectFave } from '../../CollectionPanel/redux/actionCreators';
import { getIsFavourite } from '../../CollectionPanel/redux/selectors';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { getCurrentUser } from '../../publicSession/selectors';

export type StateProps = Pick<Props, 'isFavourite' | 'currentUser'>;
export type DispatchProps = Pick<
  Props,
  'onAddToCollection' | 'addNotification'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state, ownProps: OwnProps): StateProps => ({
  currentUser: getCurrentUser(state),
  isFavourite: getIsFavourite(state, ownProps.deviation),
});

const mapDispatchToProps: DispatchProps = {
  onAddToCollection: collectFave,
  addNotification: addNotificationToQueue,
};

const connector = connect(mapStateToProps, mapDispatchToProps) as (
  component: ComponentType<Props>
) => ComponentType<OwnProps>;

export default connector;
